import { render } from "./SpaceGallery.vue?vue&type=template&id=7bca39a4&scoped=true"
import script from "./SpaceGallery.vue?vue&type=script&lang=js"
export * from "./SpaceGallery.vue?vue&type=script&lang=js"

import "./SpaceGallery.vue?vue&type=style&index=0&id=7bca39a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bca39a4"]])

export default __exports__